'use es6';

import PropTypes from 'prop-types';
import { BaseResponsiveEmptyContainerToolbar, buildActionsForEmptyColumn } from './BaseResponsiveEmptyContainerToolbar';
import { jsx as _jsx } from "react/jsx-runtime";
const MockResponsiveMobileEmptyContainerToolbarToMeasure = ({
  responsiveSize
}) => {
  // Note currently assuming buildActionsForEmptyColumn and buildActionsForEmptyRow always return
  // the same number of actions
  return /*#__PURE__*/_jsx(BaseResponsiveEmptyContainerToolbar, {
    actions: buildActionsForEmptyColumn(),
    responsiveSize: responsiveSize
  });
};
MockResponsiveMobileEmptyContainerToolbarToMeasure.propTypes = {
  responsiveSize: PropTypes.string.isRequired
};
export { MockResponsiveMobileEmptyContainerToolbarToMeasure,
// These are logically the same toolbars, so just export an alias
MockResponsiveMobileEmptyContainerToolbarToMeasure as MockResponsiveDesktopEmptyContainerToolbarToMeasure };